import React from 'react';

const ChoiceHighlighter = ({ text, choices }) => {
  if (!choices || choices.length === 0) return <span className={`text-sm text-gray-700 font-medium px-1`}>{text}</span>;

  const isMatch = choices.includes(text);

  return (
    
      isMatch ? 
        <span 
          className="text-sm text-primary-strong font-medium px-1"
          role="mark"
          aria-label={`highlighted choice: ${text}`}
        >
          {text}
        </span>
      : <span className="text-sm text-border font-medium px-1">{text}</span>

      
   
  );
};

export default ChoiceHighlighter;